module.exports = __webpack_public_path__ + "static/media/esco.e0be24d6.png";